/* global moment */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackCampaignsAddController', WinbackCampaignsAddController);

    WinbackCampaignsAddController.$inject = ['$stateParams', '$scope', '$state', 'API', 'i18n', 'debug',];

    function WinbackCampaignsAddController($stateParams, $scope, $state, API, i18n, debug) {
        $scope.$state = $state;
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.campaign = {};
        vm.winbackOffers = [];
        vm.loadingState = {
            winbackOffers: false,
        };

        activate();

        function activate() {
            loadWinbackOffers();
        }

        function loadWinbackOffers() {
            vm.loadingState.winbackOffers = true;
            var promise = API.WinbackOffer.search({ type: 'campaign' }).$promise;

            promise.then(function (response) {
                if (response.items.length) {
                    vm.winbackOffers = [];
                    angular.forEach(response.items, function (game) {
                        vm.winbackOffers.push({
                            name: game.name,
                            label: game.name,
                            value: game.id
                        });
                    });
                }
            }, function (response) {
                debug.log(response);
            })
                .finally(function () {
                    vm.loadingState.winbackOffers = false;
                });
        }

        function add() {
            var campaign = angular.copy(vm.campaign);

            if (campaign.active_from) {
                campaign.active_from = moment(campaign.active_from).format('YYYY-MM-DD 00:00:00');
            }

            if (campaign.active_to) {
                campaign.active_to = moment(campaign.active_to).format('YYYY-MM-DD 23:59:59');
            }

            if (!vm.isAdding) {
                vm.isAdding = true;

                var newCampaign = new API.WinbackCampaign(campaign);

                var promise = newCampaign.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('winbackCampaigns.edit', { id: response.id });
                }, function () {
                })
                    .finally(function () {
                        vm.isAdding = false;
                    });
            }
        }
    }
})();